var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: { inline: _vm.inline, myclass: _vm.myclass } },
    [
      _c(
        "el-form-item",
        {
          staticClass: "form_style",
          staticStyle: { display: "flex", "align-items": "center" },
          attrs: {
            label: _vm.label === undefined ? "" : _vm.label + ":",
            prop: _vm.prop,
            "label-width": _vm.labelWidth,
            rules: _vm.myrules,
          },
        },
        [_c("div", { staticStyle: { flex: "1" } }, [_vm._t("default")], 2)]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }